import { TextField } from "@mui/material";
import { isRoleArn } from "../EmrStagingIntegrationForm/EmrStagingIntegrationForm.utils";
import type { EmrAutoTuneIntegrationFormProps } from "./EmrAutoTuneIntegrationForm.types";

export default function EmrAutoTuneIntegrationForm({
  entry,
  onChange,
}: EmrAutoTuneIntegrationFormProps) {
  const roleArnInvalid = !!entry.role_arn.trim() && !isRoleArn(entry.role_arn);

  return (
    <TextField
      label="Definity role ARN"
      placeholder="arn:aws:iam::123456789012:role/definity-autotune"
      value={entry.role_arn}
      onChange={(e) => onChange({ ...entry, role_arn: e.target.value })}
      error={roleArnInvalid}
      helperText={
        roleArnInvalid
          ? "Must be an IAM role ARN (arn:aws:iam::<account-id>:role/<name>)"
          : "ARN of the definity role you created for Auto-Tune"
      }
      fullWidth
      required
      size="small"
    />
  );
}
